import { Box, BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

interface IconButtonGroupProps extends BoxProps {
  separatorColor?: string;
}
export const IconButtonGroup = styled(Box, {
  shouldForwardProp: (prop) => prop !== "separatorColor",
})<IconButtonGroupProps>(({ theme, separatorColor }) => ({
  display: "flex",

  "& > *:not(:last-child) button": {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  "& > * + * button": {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  "& > * + *": {
    borderLeft: `1px solid ${separatorColor || theme.palette.secondary[2]}`,
  },
}));
